import { createFileRoute } from '@tanstack/react-router';

import { ChapterCreate } from '@/module/Author/Chapter/ChapterCreate';

export const Route = createFileRoute('/_auth/author/_author/chapter/_chapter/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <ChapterCreate />;
}
